export default __webpack_public_path__ + "static/media/servico.48fc307d.svg";